import {loadModule} from "../../../../loadable/loadModule";

export const FlightProposalDetails: any = loadModule({
	loader: () => import("./FlightProposalDetails"),
});
